import React from 'react';

const NotificationDisconnectedIcon = ({ size = 20 }) => {
  return (
    <svg t="1600985748678" className="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="15557" width={size} height={size}>
      <path
        d="M139.989333 61.994667q24.021333 24.021333 306.986667 306.005333t427.008 429.994667l-54.016 54.016-141.994667-141.994667-166.016 205.994667-496-617.984q66.005333-54.016 155.989333-93.994667l-86.016-88.021333zM1008 297.984l-232.021333 290.005333-441.984-440.021333q89.984-20.010667 178.005333-20.010667 253.994667 0 496 169.984z"
        p-id="15558"
        data-spm-anchor-id="a313x.7781069.0.i22"
        className="selected"
        fill="#757575"
       />
    </svg>
  );
};

export default NotificationDisconnectedIcon;
